import { useState, useEffect } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import { applicationAPI } from '../services/api';

const ico = { width: '20px', height: '20px', flexShrink: 0 };

const menuGroups = [
  {
    label: 'MAIN',
    items: [
      { to: '/dashboard', label: 'Dashboard', icon: <svg style={ico} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" /></svg> },
      { to: '/admin-profile', label: 'Admin Profile', icon: <svg style={ico} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.8"><path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg> },
    ]
  },
  {
    label: 'VEHICLES',
    items: [
      { to: '/cars', label: 'Cars', match: ['/cars', '/brands'], icon: <svg style={ico} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M8 7h8m-8 4h8m-6 4h4M5 3h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2z" /></svg> },
      { to: '/bikes', label: 'Bikes', match: ['/bikes', '/bike-brands'], icon: <svg style={ico} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" /></svg> },
      { to: '/valuation', label: 'Valuation', icon: <svg style={ico} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg> },
    ]
  },
  {
    label: 'SERVICES',
    items: [
      { to: '/driving-schools', label: 'Driving Schools', icon: <svg style={ico} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M12 14l9-5-9-5-9 5 9 5z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" /></svg> },
      { to: '/rto-offices', label: 'RTO Offices', icon: <svg style={ico} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z" /></svg> },
      { to: '/cities', label: 'Cities', icon: <svg style={ico} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.8"><path strokeLinecap="round" strokeLinejoin="round" d="M3 21h18M5 21V7l7-4 7 4v14M9 9h.01M9 13h.01M9 17h.01M15 9h.01M15 13h.01M15 17h.01" /></svg> },
    ]
  },
  {
    label: 'LEARNING',
    items: [
      { to: '/question-bank', label: 'Question Bank', icon: <svg style={ico} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg> },
      { to: '/practice-questions', label: 'Practice', icon: <svg style={ico} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" /></svg> },
      { to: '/exam-questions', label: 'Exam', icon: <svg style={ico} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg> },
      { to: '/traffic-signals', label: 'Traffic Signals', icon: <svg style={ico} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg> },
      { to: '/traffic-rules', label: 'Traffic Rules', icon: <svg style={ico} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg> },
      { to: '/driving-tips', label: 'Driving Tips', icon: <svg style={ico} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M13 10V3L4 14h7v7l9-11h-7z" /></svg> },
    ]
  },
  {
    label: 'CONTENT',
    items: [
      { to: '/blogs', label: 'Blogs', icon: <svg style={ico} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" /></svg> },
      { to: '/testimonials', label: 'Reviews', icon: <svg style={ico} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.8"><path strokeLinecap="round" strokeLinejoin="round" d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg> },
      { to: '/faqs', label: 'FAQs', icon: <svg style={ico} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.8"><circle cx="12" cy="12" r="10" /><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" /><line x1="12" y1="17" x2="12.01" y2="17" /></svg> },
      { to: '/content-modules', label: 'Modules', icon: <svg style={ico} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg> },
      { to: '/external-links', label: 'URLs', icon: <svg style={ico} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" /></svg> },
      { to: '/insurance-partner-links', label: 'Insurance Links', icon: <svg style={ico} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" /></svg> },
      { to: '/exclusive-services', label: 'Exclusive Services', icon: <svg style={ico} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M13 10V3L4 14h7v7l9-11h-7z" /></svg> },
      { to: '/promotion-banners', label: 'Promotion Banners', icon: <svg style={ico} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M3 8a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z" /><circle cx="9" cy="11" r="1.4" fill="currentColor" stroke="none" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M3 16l5-5 4 4 3-3 6 6" /></svg> },
      { to: '/payment-dialogs', label: 'Payment Dialogs', icon: <svg style={ico} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.8"><rect x="2" y="5" width="20" height="14" rx="2" /><line x1="2" y1="10" x2="22" y2="10" /><line x1="6" y1="15" x2="10" y2="15" /></svg> },
      { to: '/vehicle-info', label: 'Vehicle Info', icon: <svg style={ico} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.8"><path d="M5 17h14M5 17a2 2 0 01-2-2v-3l2-5a2 2 0 012-1.5h10A2 2 0 0119 7l2 5v3a2 2 0 01-2 2" /><circle cx="7.5" cy="17" r="1.5" /><circle cx="16.5" cy="17" r="1.5" /></svg> },
      { to: '/payment-keys', label: 'Payment Keys', icon: <svg style={ico} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.8"><circle cx="8" cy="15" r="4" /><line x1="10.85" y1="12.15" x2="19" y2="4" /><line x1="18" y1="5" x2="20" y2="7" /><line x1="15" y1="8" x2="17" y2="10" /></svg> },
      { to: '/social-links', label: 'Social Links', icon: <svg style={ico} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 01-3.46 0" /></svg> },
    ]
  },
  {
    label: 'SYSTEM',
    items: [
      { to: '/applications', label: 'Applications', icon: <svg style={ico} fill="none" stroke="currentColor" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7" rx="1.5" strokeWidth={1.8} /><rect x="14" y="3" width="7" height="7" rx="1.5" strokeWidth={1.8} /><rect x="3" y="14" width="7" height="7" rx="1.5" strokeWidth={1.8} /><rect x="14" y="14" width="7" height="7" rx="1.5" strokeWidth={1.8} /></svg> },
      { to: '/screen-management', label: 'Screens', icon: <svg style={ico} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" /></svg> },
      { to: '/contact-submissions', label: 'Contact Inbox', icon: <svg style={ico} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.8"><path strokeLinecap="round" strokeLinejoin="round" d="M3 8l9 6 9-6M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg> },
    ]
  },
];

const C = {
  bg: '#ffffff',
  border: '#e5e7eb',
  text: '#64748b',
  textHover: '#1e293b',
  accent: '#4f46e5',
  accentBarBg: 'rgba(79, 70, 229, 0.08)',
  groupLabel: '#94a3b8',
  hoverBg: '#f8fafc',
};

function Sidebar({ pinned = false, onHoverChange, onTogglePin }) {
  const location = useLocation();
  const [hovered, setHovered] = useState(false);
  const [apps, setApps] = useState([]);

  // Live list of applications for quick navigation into each app's
  // platforms/placements/analytics. Refetched when route changes so newly
  // created/deleted apps appear without a full reload.
  useEffect(() => {
    let cancelled = false;
    applicationAPI.getAll()
      .then((res) => { if (!cancelled) setApps(Array.isArray(res.data?.data) ? res.data.data : []); })
      .catch(() => { if (!cancelled) setApps([]); });
    return () => { cancelled = true; };
  }, [location.pathname]);

  const updateHover = (v) => {
    setHovered(v);
    if (onHoverChange) onHoverChange(v);
  };

  // Expanded if pinned OR currently hovered
  const expanded = pinned || hovered;
  const collapsedWidth = 72;
  const expandedWidth = 240;

  const isActive = (item) => {
    if (item.match) return item.match.some(m => location.pathname.startsWith(m));
    return location.pathname === item.to || location.pathname.startsWith(item.to + '/');
  };

  return (
    <aside
      onMouseEnter={() => updateHover(true)}
      onMouseLeave={() => updateHover(false)}
      style={{
        position: 'fixed',
        left: 0,
        top: 0,
        bottom: 0,
        width: expanded ? `${expandedWidth}px` : `${collapsedWidth}px`,
        backgroundColor: C.bg,
        borderRight: `1px solid ${C.border}`,
        overflow: 'hidden',
        zIndex: pinned ? 50 : 55, // above navbar when hovering
        display: 'flex',
        flexDirection: 'column',
        transition: 'width 0.22s cubic-bezier(0.4, 0, 0.2, 1)',
        boxShadow: !pinned && hovered ? '0 8px 32px rgba(0,0,0,0.08)' : 'none',
      }}
      className="hide-scrollbar"
    >
      {/* Brand Header - Logo + Pin button */}
      <div style={{
        flexShrink: 0,
        height: '64px',
        minHeight: '64px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '6px',
        padding: expanded ? '0 12px 0 16px' : '0',
        borderBottom: `1px solid ${C.border}`,
        overflow: 'hidden',
        backgroundColor: C.bg,
      }}>
        <Link to="/dashboard" style={{
          display: 'flex',
          alignItems: 'center',
          textDecoration: 'none',
          justifyContent: expanded ? 'flex-start' : 'center',
          flex: 1,
          minWidth: 0,
          overflow: 'hidden',
        }}>
          {expanded ? (
            <img
              src={`${process.env.PUBLIC_URL || ''}/logo.svg`}
              alt="VehicleSetu"
              style={{ height: '32px', width: 'auto', objectFit: 'contain', display: 'block' }}
            />
          ) : (
            <img
              src={`${process.env.PUBLIC_URL || ''}/pwa-512x512.png`}
              alt="VehicleSetu"
              style={{ width: '40px', height: '40px', objectFit: 'contain', display: 'block' }}
            />
          )}
        </Link>
        {expanded && (
          <button
            onClick={onTogglePin}
            title={pinned ? 'Unpin sidebar (auto-hide)' : 'Pin sidebar (always show)'}
            style={{
              width: '32px', height: '32px',
              border: 'none',
              background: pinned ? '#eef2ff' : 'transparent',
              borderRadius: '8px',
              cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: pinned ? C.accent : C.groupLabel,
              transition: 'all 0.15s',
              flexShrink: 0,
            }}
            onMouseEnter={(e) => {
              if (!pinned) {
                e.currentTarget.style.background = C.hoverBg;
                e.currentTarget.style.color = C.accent;
              }
            }}
            onMouseLeave={(e) => {
              if (!pinned) {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.color = C.groupLabel;
              }
            }}
          >
            {pinned ? (
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M16 12V4h1a1 1 0 000-2H7a1 1 0 000 2h1v8l-2 2v2h5.2v6h1.6v-6H18v-2l-2-2z" />
              </svg>
            ) : (
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 17v5" />
                <path d="M9 10.76a2 2 0 01-1.11 1.79l-1.78.9A2 2 0 005 15.24V16a1 1 0 001 1h12a1 1 0 001-1v-.76a2 2 0 00-1.11-1.79l-1.78-.9A2 2 0 0115 10.76V7a1 1 0 011-1 2 2 0 000-4H8a2 2 0 000 4 1 1 0 011 1z" />
              </svg>
            )}
          </button>
        )}
      </div>

      {/* Scrollable menu content */}
      <div className="hide-scrollbar" style={{
        flex: 1,
        overflowY: 'auto',
        overflowX: 'hidden',
        padding: expanded ? '16px 16px 16px' : '16px 10px',
        minHeight: 0,
      }}>
        {menuGroups.map((group, gi) => (
          <div key={gi} style={{ marginBottom: '20px' }}>
            {/* Group label - only visible when expanded */}
            {group.label && expanded && (
              <div style={{
                fontSize: '10px',
                fontWeight: '600',
                color: C.groupLabel,
                letterSpacing: '1.4px',
                padding: '0 12px 10px',
                textTransform: 'uppercase',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
              }}>
                {group.label}
              </div>
            )}
            {group.label && !expanded && gi > 0 && (
              <div style={{
                height: '1px',
                background: C.border,
                margin: '0 6px 10px',
              }} />
            )}

            {/* Items */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
              {group.items.map((item) => {
                const active = isActive(item);
                return (
                  <div key={item.to}>
                  <NavLink
                    to={item.to}
                    title={item.label}
                    style={{
                      position: 'relative',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '12px',
                      padding: expanded ? '10px 12px' : '11px',
                      borderRadius: '8px',
                      fontSize: '14px',
                      fontWeight: active ? '600' : '500',
                      textDecoration: 'none',
                      color: active ? C.accent : C.text,
                      background: active ? C.accentBarBg : 'transparent',
                      transition: 'color 0.12s, background 0.12s',
                      justifyContent: expanded ? 'flex-start' : 'center',
                    }}
                    onMouseEnter={(e) => {
                      if (!active) {
                        e.currentTarget.style.background = C.hoverBg;
                        e.currentTarget.style.color = C.textHover;
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!active) {
                        e.currentTarget.style.background = 'transparent';
                        e.currentTarget.style.color = C.text;
                      }
                    }}
                  >
                    {active && (
                      <span style={{
                        position: 'absolute',
                        left: 0, top: '8px', bottom: '8px',
                        width: '3px',
                        background: C.accent,
                        borderRadius: '0 3px 3px 0',
                      }} />
                    )}
                    <span style={{
                      flexShrink: 0,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}>
                      {item.icon}
                    </span>
                    {expanded && (
                      <span style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        flex: 1,
                      }}>
                        {item.label}
                      </span>
                    )}
                  </NavLink>

                  {/* App list nested directly under the Applications entry.
                      Click → that app's ads configuration (platforms /
                      placements / analytics). */}
                  {item.to === '/applications' && expanded && apps.length > 0 && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', margin: '2px 0 6px 0' }}>
                      {apps.map((a) => {
                        const to = `/applications/${a.id}`;
                        const aActive = location.pathname === to;
                        return (
                          <NavLink
                            key={a.id}
                            to={to}
                            title={a.name}
                            style={{
                              display: 'flex', alignItems: 'center', gap: '10px',
                              padding: '7px 12px 7px 28px', borderRadius: '8px', fontSize: '13px',
                              fontWeight: aActive ? '600' : '500', textDecoration: 'none',
                              color: aActive ? C.accent : C.text,
                              background: aActive ? C.accentBarBg : 'transparent',
                            }}
                            onMouseEnter={(e) => { if (!aActive) { e.currentTarget.style.background = C.hoverBg; e.currentTarget.style.color = C.textHover; } }}
                            onMouseLeave={(e) => { if (!aActive) { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = C.text; } }}
                          >
                            <span style={{
                              width: '18px', height: '18px', borderRadius: '5px', flexShrink: 0,
                              background: '#eef2ff', color: C.accent, display: 'flex',
                              alignItems: 'center', justifyContent: 'center', fontSize: '10px', fontWeight: 700,
                            }}>
                              {(a.name || '?').charAt(0).toUpperCase()}
                            </span>
                            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1 }}>
                              {a.name}
                            </span>
                          </NavLink>
                        );
                      })}
                    </div>
                  )}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>

      {/* Version footer - only when expanded */}
      {expanded && (
        <div style={{
          flexShrink: 0,
          padding: '12px 20px',
          borderTop: `1px solid ${C.border}`,
          fontSize: '11px',
          color: C.groupLabel,
          fontWeight: '500',
          letterSpacing: '0.5px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          backgroundColor: C.bg,
          textAlign: 'center',
        }}>
          v1.0.0
        </div>
      )}
    </aside>
  );
}

export default Sidebar;
